var render = function render(){var _vm=this,_c=_vm._self._c;return _c('Link',{attrs:{"href":'/'}},[_c('img',{staticClass:"h-20",attrs:{"src":"/images/logo/logo.svg","alt":"logo"}})])
}
var staticRenderFns = []

export { render, staticRenderFns }